import {Component, OnInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {ModalComponent} from '@app/shared/components';
import {Log} from 'ng2-logger';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-tool-ersa-confirmation-modal',
    templateUrl: './tool-ersa-confirmation-modal.component.html',
    styleUrls: ['./tool-ersa-confirmation-modal.component.scss']
})

export class ToolAtErsaConfirmationModalComponent implements OnInit {
    _logger = Log.create(ToolAtErsaConfirmationModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output() clickSelection = new EventEmitter<any>();

    areAllToolsNeededAtErsa = false;
    tools: any;

    constructor(public translateService: TranslateService) {
    }

    ngOnInit() {
    }

    open(tools: any, areAllToolsNeededAtErsa: boolean) {
        this.tools = tools;
        this.areAllToolsNeededAtErsa = areAllToolsNeededAtErsa;
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onClickSelection(value) {
        this.clickSelection.emit(value);
    }

    getTitle() {
        return this.translateService.instant('lineSetter.tool-returns.pages.ersaBayModal.title');
    }
}
